import type { VoterCountsResponse } from '../generated/dtos.gen';
import {
  VOTER_DATA_DELIVERED_COUNT_CONTACT_CAP_CENTS,
  VOTER_DATA_DELIVERED_COUNT_TOLERANCE,
  VOTER_DATA_PRICE_PER_RECORD_CENTS,
} from '../generated/constants.gen';

// Voter data segment builder. Counts come only
// from L2's free count endpoints (ADR-091); the builder is exempt from the paywall (ADR-090).

/** What L2 counted for a segment: the same whatever the list's purpose or one per household, so without the price. */
export type VoterCounts = Omit<VoterCountsResponse, 'records' | 'priceCents' | 'belowMinimum'>;

/**
 * How many records a delivered file may differ from the quote by before the customer is contacted:
 * the smaller of 5% of the quote and $50 worth of records, in whole records. The same rule as
 * VoterDataPricing.DeliveredCountAllowance.
 */
export function deliveredCountAllowance(quotedRecords: number): number {
  return Math.min(
    Math.floor(quotedRecords * VOTER_DATA_DELIVERED_COUNT_TOLERANCE),
    Math.floor(VOTER_DATA_DELIVERED_COUNT_CONTACT_CAP_CENTS / VOTER_DATA_PRICE_PER_RECORD_CENTS),
  );
}

/** True when delivering `deliveredCount` records needs the customer contacted first. */
export function deliveredCountNeedsConfirmation(quotedRecords: number, deliveredCount: number): boolean {
  return Math.abs(deliveredCount - quotedRecords) > deliveredCountAllowance(quotedRecords);
}
